module.exports = __webpack_public_path__ + "img/ringwedding.859939c.jpg";